<div class="ir-item-line th-filter th-filter--expand installation">
  <div
    (click)="setOrderBy(inspectionOrderField.ByStartDate)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByStartDate === extendedColumn }"
    class="ir-item-cell size-custom size-custom--startdate installation clickable active"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.start-date' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByStartDate }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByName)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByName === extendedColumn }"
    class="ir-item-cell size-custom size-custom--name installation clickable"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.project' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByName }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByCustomer)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByCustomer === extendedColumn }"
    class="ir-item-cell size-custom size-custom--customer installation clickable"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.customer' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByCustomer }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByEquipmentType)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByEquipmentType === extendedColumn }"
    class="ir-item-cell size-custom size-custom--equipment installation clickable"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.equipement-type' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByEquipmentType }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByFST)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByFST === extendedColumn }"
    class="ir-item-cell size-custom size-custom--fst installation clickable right"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.fst' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByFST }"></ng-container>
  </div>
  <ng-template #sortIcons>
    <ng-container *ngIf="showSorting">
      <i class="material-icons" *ngIf="orderBy < 0">arrow_drop_up</i>
      <i class="material-icons" *ngIf="orderBy >= 0">arrow_drop_down</i>
    </ng-container>
  </ng-template>
  <ng-template #expandIcons let-column>
    <i class="material-icons" (click)="extend($event, column)" *ngIf="column === extendedColumn; else unfoldMore"
      >unfold_less</i
    >
    <ng-template #unfoldMore><i class="material-icons" (click)="extend($event, column)">unfold_more</i></ng-template>
  </ng-template>
</div>
<div class="ir-content-flow has-filter" (scroll)="scroll($event)">
  <div
    class="ir-item-line th-inspection clickable"
    [ngClass]="{
      'offline-not-loaded': (!inspection?.lastSyncDate && !isConnection) || inspection?.status === -50,
      'new-inspection': inspection?.isNew
    }"
    (click)="selectInspection(inspection)"
    *ngFor="let inspection of inspections"
  >
    <div
      class="ir-item-cell size-custom size-custom--startdate installation"
      [ngClass]="{ fullwidth: inspectionOrderField.ByStartDate === extendedColumn }"
    >
      <span>{{ inspection?.startDate | formatDate }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--name installation"
      [ngClass]="{ fullwidth: inspectionOrderField.ByName === extendedColumn }"
    >
      <span>{{ inspection?.name }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--customer installation"
      [ngClass]="{ fullwidth: inspectionOrderField.ByCustomer === extendedColumn }"
    >
      <span>{{ inspection?.customerName }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--equipment installation important"
      [ngClass]="{ fullwidth: inspectionOrderField.ByEquipmentType === extendedColumn }"
    >
      <span [title]="inspection?.equipementType">{{ inspection?.equipementType }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--fst installation right"
      [ngClass]="{ fullwidth: inspectionOrderField.ByFST === extendedColumn }"
    >
      <i *ngIf="inspection?.isOffline && !inspection?.updatedOffline" class="material-icons list-icon offline"
        >offline_pin</i
      >
      <i *ngIf="inspection?.isOffline && inspection?.updatedOffline" class="material-icons list-icon warning"
        >offline_pin</i
      >
      <i *ngIf="!inspection?.isOffline && inspection?.lastSyncDate && !isConnection" class="material-icons list-icon"
        >visibility</i
      >
      <i *ngIf="!inspection?.isOffline && inspection?.isSynchronizing" class="material-icons list-icon offline">sync</i>
      <span>{{ inspection?.technicianName }}</span>
    </div>
  </div>

  <div class="ir-item-empty ir-mv8" *ngIf="inspections?.length == 0">
    <p>
      <span>{{ 'inspections.no-inspections' | translate }}</span>
    </p>
  </div>
</div>
<!-- End content flow -->
